// extracted by mini-css-extract-plugin
export default {"Container":"AddBook_Container__iKimZ","Created":"AddBook_Created__F2ial"};